// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"8b89d85e","733":"4441b339","954":"b55003d4"}[chunkId] + ".chunk.css";
};